var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 26C52 40.3594 40.3594 52 26 52C11.6406 52 -1.2401e-08 40.3594 -1.2401e-08 26C-1.2401e-08 11.6406 11.6406 0 26 0C40.3594 0 52 11.6406 52 26Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 0C20.8577 0 15.8309 1.52487 11.5552 4.38179C7.2795 7.23871 3.94701 11.2994 1.97913 16.0502C0.011254 20.8011 -0.503633 26.0288 0.499583 31.0723C1.5028 36.1159 3.97906 40.7486 7.61522 44.3848C11.2514 48.0209 15.8841 50.4972 20.9277 51.5004C25.9712 52.5036 31.1989 51.9887 35.9498 50.0209C40.7006 48.053 44.7613 44.7205 47.6182 40.4448C50.4751 36.1691 52 31.1423 52 26C51.9868 19.1084 49.2433 12.5029 44.3702 7.62982C39.4971 2.75674 32.8916 0.0132149 26 0ZM38.375 21.45L23.725 35.45C23.3463 35.8063 22.845 36.0032 22.325 36C22.0708 36.0036 21.8185 35.9569 21.5825 35.8625C21.3465 35.7681 21.1315 35.6279 20.95 35.45L13.625 28.45C13.4218 28.2727 13.2566 28.0562 13.1392 27.8135C13.0219 27.5708 12.9548 27.3068 12.9421 27.0375C12.9293 26.7681 12.9712 26.499 13.0651 26.2463C13.159 25.9935 13.3031 25.7624 13.4886 25.5668C13.6741 25.3711 13.8973 25.215 14.1447 25.1078C14.3921 25.0006 14.6586 24.9445 14.9282 24.943C15.1978 24.9414 15.465 24.9944 15.7136 25.0987C15.9622 25.203 16.1872 25.3565 16.375 25.55L22.325 31.225L35.625 18.55C36.0139 18.2107 36.5189 18.0349 37.0344 18.0593C37.5499 18.0837 38.036 18.3064 38.3911 18.6809C38.7462 19.0553 38.9428 19.5526 38.9398 20.0687C38.9368 20.5847 38.7344 21.0797 38.375 21.45Z",
    fill: "url(#paint0_linear_0_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_7",
    x1: 26,
    y1: 0,
    x2: 26,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31D8D6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.72ca09be.svg";
export { ForwardRef as ReactComponent };